// UserMoreJsonLd.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import serialize from 'serialize-javascript';
import { withTranslation } from 'react-i18next';

import { getPerson } from '../resource/SchemaObject.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

export class UserMoreJsonLd extends React.PureComponent {
  render() {
    const { category, userDataList, t } = this.props;
    const pageTitle = `${t(category, {
      ns: TranslationNamespace.FEED,
    })} - ${t('seo-home-title', {
      ns: TranslationNamespace.SEO,
    })}`;
    return (
      <Helmet>
        <script type="application/ld+json" helmetkey="jsonld">
          {serialize(
            {
              '@context': 'https://schema.org',
              '@graph': [
                {
                  '@type': 'WebPage',
                  '@id': `https://swag.live/user-categories/${category}#webpage`,
                  url: `https://swag.live/user-categories/${category}`,
                  name: pageTitle,
                  breadcrumb: {
                    '@id': `https://swag.live/user-categories/${category}#breadcrumb`,
                  },
                  mainEntity: {
                    '@id': `https://swag.live/user-categories/${category}#feed`,
                  },
                },
                {
                  '@type': 'BreadcrumbList',
                  '@id': `https://swag.live/user-categories/${category}#breadcrumb`,
                  itemListElement: [
                    {
                      '@type': 'ListItem',
                      position: 1,
                      name: t('seo-home-title', {
                        ns: TranslationNamespace.SEO,
                      }),
                      item: 'https://swag.live',
                    },
                    {
                      '@type': 'ListItem',
                      position: 2,
                      name: t('seo_video_title', {
                        ns: TranslationNamespace.SEO,
                      }),
                      item: 'https://swag.live/video',
                    },
                    {
                      '@type': 'ListItem',
                      position: 3,
                      name: pageTitle,
                      item: `https://swag.live/user-categories/${category}`,
                    },
                  ],
                },
                {
                  '@type': 'ItemList',
                  '@id': `https://swag.live/user-categories/${category}#feed`,
                  url: `https://swag.live/user-categories/${category}`,
                  itemListElement: userDataList.map((userData, index) => ({
                    '@type': 'ListItem',
                    position: index + 1,
                    item: {
                      '@id': `https://swag.live/user/${userData.id}#person`,
                    },
                  })),
                },
                ...userDataList.map(userData => {
                  return getPerson({
                    id: userData.id,
                    username: userData.username,
                  });
                }),
              ],
            },
            { isJSON: true }
          )}
        </script>
      </Helmet>
    );
  }
}

UserMoreJsonLd.propTypes = {
  category: PropTypes.string,
  userDataList: PropTypes.array,
  t: PropTypes.func.isRequired,
};

UserMoreJsonLd.defaultProps = {
  category: '',
  userDataList: [],
};

export default withTranslation()(UserMoreJsonLd);
